import WorkerProfile from '@worker/components/WorkerProfile/WorkerProfile';

function WorkerProfilePage() {
  return <WorkerProfile />;
}

export default WorkerProfilePage;
